import { useQuery } from "react-query";
import {
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_SortingState,
} from "mantine-react-table";
import getTransactionsData, {
  TransactionsResponse,
} from "../services/getTransactionsData";
function useGetTransactionsData(
  token: string,
  pagination: MRT_PaginationState,
  columnFilters: MRT_ColumnFiltersState,
  sorting: MRT_SortingState
) {
  return useQuery<TransactionsResponse>({
    queryKey: ["get-transaction-data", pagination, columnFilters, sorting],
    queryFn: () =>
      getTransactionsData({ token, pagination, columnFilters, sorting }),
    retry: false,
    keepPreviousData: true,
    staleTime: 30_000,
  });
}

export default useGetTransactionsData;
